import Carousel from "../react_components/carousel/carousel";
import HeroImage from "../react_components/hero_image";
import JobsList from "../react_components/jobs_list";
import LeadParagraph from "../react_components/lead_paragraph";
import SkipLink from "../react_components/skip_link";

import CarouselStore from "../react_stores/carousel_store";

export const JobsComponents = {
  Carousel,
  HeroImage,
  JobsList,
  LeadParagraph,
  SkipLink,
};

export const JobsStores = {
  CarouselStore,
};
